<template>
    <v-container fluid>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Declined Messages ({{totalMatches}})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field v-show="false"
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <!--<v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>-->
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="declinedmessages === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    lg="6"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="declinedmessage.id"
                    cols="12"
                    lg="6"
                    v-for="declinedmessage in declinedmessages"
                >
                    <!--@click="loadDeclinedmessageForm(declinedmessage.entity)"-->
                    <v-card
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow:hidden"
                    >
                        <v-card-title>
                            <h5>{{declinedmessage.smsNumber}}</h5>
                        </v-card-title>
                        <v-card-text class="pt-0">MessageSent: {{declinedmessage.messageSent}}</v-card-text>
                        <v-card-text class="pt-0">MessageSentAt: {{declinedmessage.createdAt.toString()}}</v-card-text>
                        <br/>
                        <v-card-text class="pt-0">MessageReceived: {{declinedmessage.messageRecieved}}</v-card-text>
                        <v-card-text class="pt-0">MessageReceivedAt: {{declinedmessage.actionedAt.toString()}}</v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>


        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import Declinedmessage from "../models/Declinedmessage.model";
import uuid4 from "../helpers/uuid4";

export default {
    name: "DeclinedMessages",
    props: ["status"],
    data: function() {
        return {
            //main data
            declinedmessages: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),

            //form
            //declinedmessageFormVisible: false,
            //declinedmessageFormKey: 0,
            //declinedmessageFormDeclinedmessage: new Declinedmessage()
        };
    },
    mounted: function() {
        this.getDeclinedMessages();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        //DeclinedmessageForm
        //
    },
    methods: {
        getDeclinedMessages() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("sms/getsmsreplyaction", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder
                    },
                    requestId: requestId
                })
                .then(declinedmessagesResponse => {
                    if (this.requestId == declinedmessagesResponse.requestId) {
                        this.declinedmessages = declinedmessagesResponse.data.page;
                        this.totalMatches = declinedmessagesResponse.data.total;
                        this.pageSize = declinedmessagesResponse.data.pageSize;
                        this.pageNo = declinedmessagesResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            declinedmessagesResponse.data.total / this.pageSize
                        );
                    }
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.declinedmessages !== null) this.declinedmessages = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getDeclinedMessages,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },

        //FORM METHODS---------------------------------
        /*
        newDeclinedmessage() {
            var declinedmessage = new Declinedmessage();
            declinedmessage.id = 0;
            this.loadDeclinedmessageForm(declinedmessage);
        },
        loadDeclinedmessageForm(declinedmessage) {
            this.declinedmessageFormDeclinedmessage = new Declinedmessage().set(declinedmessage);
            this.declinedmessageFormKey = declinedmessage.id;
            this.declinedmessageFormVisible = true;
        },
        closeDeclinedmessageForm() {
            this.declinedmessageFormVisible = false;
            this.declinedmessageFormDeclinedmessage = new Declinedmessage();
            this.declinedmessageFormKey = null;
        },
        updateDeclinedmessage() {
            this.paginationDebounce(0);
        },
        deleteDeclinedmessage() {
            this.paginationDebounce(0);
        }
        */
    }
};
</script>

<style lang="stylus" scoped>
.entity-card
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content
        background-color: rgba(127, 127, 127, 0.15)

.pagination-bar
    // position: fixed;
    bottom: 0
    margin: auto
    left: 0
    right: 0
    padding-bottom: 0.1rem
    padding-top: 0.1rem
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */

.theme--light
    .base-background
        background: #FFFFFF

.theme--dark
    .base-background
        background: #121212
</style>
